/**
 * Fields whose options belong to a choice made in another field of the same
 * skill (`groupedBy`): the niches of the practice areas the firm serves.
 * Each option carries its `group` (the value in the parent field) and
 * `groupLabel`.
 */

/** Groups of the options for the parent's current selection, in the parent's order. */
export function visibleGroups(options, parentSelection) {
  const chosen = Array.isArray(parentSelection) ? parentSelection : [];
  return chosen
    .map((group) => {
      const items = options.filter((o) => o.group === group);
      return items.length ? { group, label: items[0].groupLabel || group, options: items } : null;
    })
    .filter(Boolean);
}

/**
 * Values of a skill after `changed` was set: drops choices of grouped fields
 * whose group is no longer selected, so no hidden selection is sent.
 */
export function pruneGrouped(fields, skillValues, changed) {
  let next = skillValues;
  for (const field of fields || []) {
    if (field.groupedBy !== changed || !Array.isArray(next[field.name])) continue;
    const parent = new Set(Array.isArray(next[changed]) ? next[changed] : []);
    const groupOf = new Map((field.options || []).map((o) => [o.value, o.group]));
    const kept = next[field.name].filter((v) => parent.has(groupOf.get(v)));
    if (kept.length !== next[field.name].length) next = { ...next, [field.name]: kept };
  }
  return next;
}
